// Import components
import "../../components/material-toggle.js";
import "../../components/paper-options.js";
import "../../components/framed-poster-options.js";
import "../../components/acryl-options.js";
import "../../components/aluminium-options.js";
import "../../components/tegel-options.js";
import "../../components/gift-options.js";
import "../../components/wallable-watermark.js";

import "html2canvas";
import "@woocommerce/woocommerce-rest-api";

import html2canvas from "html2canvas";
import * as $ from "jquery";
import * as bootstrap from "bootstrap";
import nlWordsArchive from "./words/words.json";
import deWordsArchive from "./words/words.de.json";
import { Options } from "./options-woordenboek-poster.js";
import { getShippingDate } from "./helpers/shipping-date.js";
import { resizePosterPreview } from "./helpers/resize-poster-preview.js";
import { getShoppingBagSummary } from "./helpers/shopping-bag-summary.js";
import { DebugReporter } from "./helpers/debug-reporter.js";
import { uploadProductScreenshot } from "./helpers/image-uploader.js";
import { initializeI18n } from "./i18n/initialize.js";
import { resolveCatalogProduct } from "./catalog/product-catalog.js";
import { getBuilderUrl } from "./config/builder-routes.js";
let wordsArchive = nlWordsArchive;

let woocommerceUrl = process.env.WOOCOMMERCE_URL || window.location.origin;
const apiBase = "";
let marketContext;
let t = (key) => key;
let formatCurrency = (value) => `€${Number(value).toFixed(2).replace(".", ",")}`;
let formatDate = (value) => String(value);
const i18nReady = initializeI18n().then((i18n) => {
  ({ marketContext, t, formatCurrency, formatDate } = i18n);
  woocommerceUrl = marketContext.services.woocommerceBaseUrl;
  wordsArchive = marketContext.market === "de" ? deWordsArchive : nlWordsArchive;
  wordsArchive.words.sort((a, b) =>
    a.word.localeCompare(b.word, marketContext.locale),
  );
  getSavedPoster();
  toggleProductionEnv();
  calculatePosterPrice();
  resizePosterWrapper();
  toggleClearIcons();
  loadStoredWords();
  getWordFromQuery();
  setPreviewMode();
});

const options = new Options();

let PosterPreviewImage, WordsModal, wordQueryParam;
let ShowMobileSettingPanel = false;
let PrintTypeSelected = true;
const BuilderName = $("body").attr("id");

let SettingsPanel = options.get("settingsPanel", "map");
let PosterSize = options.get("posterSize", "small");
let PosterFrame = options.get("posterFrame", "black");
let PrintType = options.get("printType", "paper");
let AluminiumColor = options.get("aluminiumColor", "silver");
let AcrylBlock = options.get("acrylBlock", "no-block");
let GiftCardText = "";
let defaultWordFontSize = 10;

const WordInput = $("#word-input");
const WordLabel = $(".labels .word");
const PronounceInput = $("#pronounce-input");
const PronounceLabel = $(".labels .pronounce");
const WordTypeInput = $("#word-type-input");
const WordTypeLabel = $(".labels .word-type");
const DescriptionInput = $("#description-input");
const DescriptionLabel = $(".labels .description");
const PosterWrapper = $(".map-wrapper");
const PosterSizeSelect = $(".js-poster-size");
const PosterFrameSelect = $(".js-poster-frame");
const PosterGiftwrapSelect = $(".js-giftwrap");
const GiftCardSelect = $(".js-giftcard");
const wordsList = $(".js-words");
const AcrylBlockSelect = $(".js-acryl-block");
const PrintTypeSelect = $(".js-print-type");
const PrintStandSelect = $(".js-acryl-block");
const PrintStandUI = $(".acryl-block");
const PosterFrameUI = $(".poster-frame");
const MapWrapper = $(".map-wrapper");

const debugReporter = DebugReporter({
  ajaxUrl: apiBase + "/wp-json/wallable/v1/client-diagnostics",
  containerSelector: ".js-notifications",
  shouldShow: ({ meta }) =>
    meta?.action === "add-to-cart" || meta?.action === "add-poster-order",
  extraContext: () => ({
    builder: $("body").attr("id"),
  }),
}).init();

// For dismissing panel if previewing from shopping cart
function setPreviewMode() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("preview")) {
    dismissSettingsPanel();
  }
}

$(document).ready(function () {
  window.status = "mapbox-ready";
  setTimeout(() => {
    $(".anim-wrapper").removeClass("hidden");
    $(".loading-wrapper").remove();
    scaleFontSize();
  }, 500);
});

// Input listeners
$("input.form-control, textarea.form-control").on("input", function () {
  const posterLabel = this.dataset.posterLabel;

  if (!posterLabel || posterLabel === "search-list") return;

  const inputValue = $(this).val();

  $(".labels ." + posterLabel).html(inputValue);

  if (posterLabel === "word") {
    scaleFontSize();
  }

  $('.js-clear-input[data-field-id="' + posterLabel + '"]').toggle(
    inputValue !== "",
  );
});

$(".js-history-back").on("click", function () {
  history.back();
});

// Clear input fields
$(".js-clear-input").on("click", function () {
  const field = $(this).data("field-id");

  if (field === "search-list") {
    $('input.form-control[data-poster-label="search-list"]')
      .val("")
      .trigger("input")
      .trigger("focus");

    loadStoredWords();
    return;
  }

  $(
    'input.form-control[data-poster-label="' +
      field +
      '"], ' +
      'textarea.form-control[data-poster-label="' +
      field +
      '"]',
  )
    .val("")
    .trigger("input")
    .trigger("focus");
});

// Check if field has value and show clear icon
function toggleClearIcons() {
  const inputFields = $("input.form-control");
  const textAreas = $("textarea.form-control");

  inputFields.each(function () {
    const inputValue = $(this).val();

    if (inputValue.trim() === "") {
      let emptyField = $(this).data("poster-label");
      $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
    }
  });

  textAreas.each(function () {
    const inputValue = $(this).val();

    if (inputValue.trim() === "") {
      let emptyField = $(this).data("poster-label");
      $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
    }
  });
}

function scaleFontSize() {
  const text = $(".js-poster-word");
  const textWrapper = $(".word-wrapper");

  // Reset font size to the default value
  text.css("font-size", defaultWordFontSize + "em");

  // Calculate the current text width
  const textWidth = text[0].scrollWidth;

  // Calculate the container width
  const containerWidth = textWrapper.width();

  // If the text width exceeds the container width, shrink the font size
  if (textWidth > containerWidth) {
    const newFontSize = defaultWordFontSize * (containerWidth / textWidth);
    text.css("font-size", newFontSize + "em");
  }
}

// Change print type
$(document).on("click", ".js-print-option", function () {
  let SelectedPrintType = $(this).attr("data-print");
  if (PrintType !== SelectedPrintType) {
    PrintType = SelectedPrintType;
    setPrintType(PrintType);
  }
  if ($(this).hasClass("d-block")) {
    PrintTypeSelected = true;
  }
  togglePrintTypes();
});

$(document).on("click", ".js-show-print-types", function () {
  togglePrintTypes();
});

function setPrintType(PrintType) {
  var selectedPrint = $('.js-print-option[data-print="' + PrintType + '"]');
  $(".js-print-option").removeClass("active");
  $(".block-wrapper, body").removeClass("tegel");
  selectedPrint.addClass("active");

  // If acryl
  if (PrintType == "acryl") {
    if (PosterSize === "large" || PosterSize === "extra-large") {
      PosterSize = "small";
    }
    PosterFrame = "no-frame";

    // If aluminium
  } else if (PrintType == "aluminium") {
    if (PosterSize === "large" || PosterSize === "extra-large") {
      PosterSize = "medium";
    }
    PosterFrame = "no-frame";
    setAluminiumColor(AluminiumColor);

    // If Tegel
  } else if (PrintType == "tegel") {
    PosterSize = "small";
    $(".block-wrapper, body").addClass("tegel");
    PosterFrame = "no-frame";

    // If paper
  } else {
    if (PosterSize === "xs") {
      PosterSize = "small";
    } else if (PosterSize === "extra-large") {
      PosterSize = "large";
    }
    AcrylBlock = "no-block";
  }
  setStandSelection(AcrylBlock);
  setFrameSelection(PosterFrame);
  setPosterFrame(PosterFrame);
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);
  setPrintStand(AcrylBlock);
  calculatePosterPrice();
}

function togglePrintTypes() {
  if (PrintTypeSelected) {
    $(".js-print-option").hide();
    $(".js-toggle-for-material").hide();
    $(".js-show-print-types").show();
    $(".js-toggle-for-material[data-material='" + PrintType + "']").show();
    $(".js-print-option[data-print='" + PrintType + "']").show();
    PrintTypeSelected = false;
  } else {
    $(".js-print-option").show();
    $(".js-show-print-types").hide();
    $(".js-toggle-for-material").hide();
    PrintTypeSelected = true;
  }
}

// Changing poster
function setPosterSize(posterSize) {
  PosterWrapper.removeClass().addClass(
    "map-wrapper size-" + posterSize + " " + PrintType,
  );
}

// Change poster size
$(".js-size-option").on("click", function () {
  PosterSize = $(this).attr("data-size");
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);
  calculatePosterPrice();
});

function setSizeSelection(posterSize) {
  let selectedSize = $(
    '.js-toggle-for-material[data-material="' +
      PrintType +
      '"] .js-size-option[data-size="' +
      posterSize +
      '"]',
  );

  $(".js-size-option").removeClass("active");
  selectedSize.addClass("active");

  if (PrintType !== "paper") return;

  let framePrice = 0;
  let frameNormalPrice = 0;
  switch (posterSize) {
    case "small":
      framePrice = 15;
      frameNormalPrice = 21.95;
      break;
    case "medium":
      framePrice = 20;
      frameNormalPrice = 24.95;
      break;
    case "large":
      framePrice = 35;
      frameNormalPrice = 39.95;
      break;
    default:
      framePrice = 0;
      frameNormalPrice = 0;
  }

  // If extra-large, force no frame
  if (posterSize === "extra-large") {
    PosterFrame = "no-frame";
    setFrameSelection(PosterFrame);
    setPosterFrame(PosterFrame);
    $(".js-frame-option").addClass("disabled");
    $('.js-frame-option[data-frame="no-frame"]').removeClass("disabled");
    $("small[frame-normal-price]").text("-");
    $("small[frame-price]").hide();
  } else {
    $(".js-frame-option").removeClass("disabled");
    $("small[frame-price]").show();
    $("small[frame-price]").text(formatCurrency(framePrice));
    $("small[frame-normal-price]").text(formatCurrency(frameNormalPrice));

    $(".js-frame-option")
      .not('[data-frame="no-frame"]')
      .attr("data-price", framePrice.toFixed(2));
  }
}

// Change aluminium color
$(document).on("click", ".js-color-option", function () {
  AluminiumColor = $(this).attr("data-color");
  setAluminiumColor(AluminiumColor);
  setAluminiumColorSelection(AluminiumColor);
});

function setAluminiumColor(color) {
  MapWrapper.attr("data-aluminium-color", color);
}

function setAluminiumColorSelection(color) {
  var selectedColor = $('.js-color-option[data-color="' + color + '"]');
  $(".js-color-option").removeClass("active");
  selectedColor.addClass("active");
}

// Change acryl block
$(document).on("click", ".js-block-option", function () {
  AcrylBlock = $(this).attr("data-block");
  setStandSelection(AcrylBlock);
  setPrintStand(AcrylBlock);
  calculatePosterPrice();
});

function setStandSelection(AcrylBlock) {
  var selectedBlock = $('.js-block-option[data-block="' + AcrylBlock + '"]');
  $(".js-block-option").removeClass("active");
  selectedBlock.addClass("active");
}

function setPrintStand(AcrylBlock) {
  const isBlackBlock = AcrylBlock === "black";
  const isOakBlock = AcrylBlock === "oak";
  const hasBlock = isBlackBlock || isOakBlock;

  const isBlackFrame = AcrylBlock === "black-frame";
  const isOakFrame = AcrylBlock === "oak-frame";
  const hasFrame = isBlackFrame || isOakFrame;

  MapWrapper.attr("data-perspective", hasBlock);

  if (hasFrame) {
    PrintStandUI.addClass("d-none");
    PosterFrameUI.removeClass("d-none");
    if (isBlackFrame) {
      setPosterFrame("tile black");
    } else if (isOakFrame) {
      setPosterFrame("tile oak");
    }
  } else if (hasBlock) {
    PrintStandUI.removeClass("black oak d-none");
    PosterFrameUI.addClass("d-none");

    if (isBlackBlock) {
      PrintStandUI.addClass("black");
    } else if (isOakBlock) {
      PrintStandUI.addClass("oak");
    } else {
      PrintStandUI.addClass("d-none");
    }

    PrintStandUI.toggleClass("hide-shadow", PrintType === "tegel");
  } else {
    if (PrintType !== "paper") {
      PosterFrameUI.addClass("d-none");
    }
    PrintStandUI.addClass("d-none");
  }
}

// Change poster frame
$(".js-frame-option").on("click", function () {
  PosterFrame = $(this).attr("data-frame");
  setFrameSelection(PosterFrame);
  setPosterFrame(PosterFrame);
  activateGiftwrap(PosterFrame);
  calculatePosterPrice();
});

function setPosterFrame(PosterFrame) {
  const frameClasses = [
    "black-frame",
    "oak-frame",
    "white-frame",
    "tile black-frame",
    "tile oak-frame",
  ];

  PosterFrameUI.removeClass(frameClasses.join(" ") + " d-none");

  if (frameClasses.includes(PosterFrame + "-frame")) {
    PosterFrameUI.addClass(PosterFrame + "-frame");
  } else {
    PosterFrameUI.addClass("d-none");
  }
  activateGiftwrap();
}

function setFrameSelection(frame) {
  var selectedFrame = $('.js-frame-option[data-frame="' + frame + '"]');
  $(".js-frame-option").removeClass("active");
  selectedFrame.addClass("active");
}

// Toggle giftwrap
$(".js-giftwrap").on("change", function () {
  calculatePosterPrice();
});

function activateGiftwrap() {
  if (PrintType === "paper" && PosterFrame === "no-frame") {
    PosterGiftwrapSelect.val("false");
    $(".js-giftwrap option[value=true]")
      .attr("disabled", "disabled")
      .siblings()
      .removeAttr("disabled");
  } else {
    $(".js-giftwrap option[value=true]").removeAttr("disabled");
  }
}

// Change giftcard text
$(".js-giftcard").on("change", function () {
  if ($(this).val() === "true") {
    $(".js-giftcard-text").show();
    GiftCardText = $(".js-giftcard-text").val();
  } else {
    $(".js-giftcard-text").hide();
    GiftCardText = "";
  }
  calculatePosterPrice();
});

$(".js-giftcard-text").on("change", function () {
  GiftCardText = $(this).val();
});

// Calculate poster price
function calculatePosterPrice() {
  const getPrice = (selector) =>
    parseFloat($(selector).find(".active, :selected").attr("data-price")) || 0;

  // Scope material-specific selectors to only the visible material
  const activeMaterialDiv = `.js-toggle-for-material[data-material="${PrintType}"]`;

  const subtotalPrice =
    getPrice(`${activeMaterialDiv} .js-poster-size`) +
    getPrice(`${activeMaterialDiv} .js-acryl-block`) +
    getPrice(PosterFrameSelect) +
    getPrice(PosterGiftwrapSelect) +
    getPrice(GiftCardSelect);

  $(".subtotal").html(formatCurrency(subtotalPrice));
}

// Create poster preview image
function createPosterPreview() {
  $(".poster-frame, .block-wrapper").addClass("hidden");
  $(".map-wrapper").addClass("shadow-none");
  const element = document.querySelector(".poster-wrapper");

  html2canvas(element, {
    scale: window.devicePixelRatio || 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  }).then((canvas) => {
    PosterPreviewImage = canvas.toDataURL("image/jpeg", 0.8);
    $(".js-poster-preview").attr("src", PosterPreviewImage);
  });
  $(".map-wrapper").removeClass("shadow-none");
  $(".poster-frame, .block-wrapper").removeClass("hidden");
}

// Get list of stored words
function loadStoredWords() {
  wordsList.html("");
  wordsArchive.words.forEach((word) => {
    wordsList.append(
      `<a href="#" class="list-group-item list-group-item-action" data-word="${word.word}">${word.word}</a>`,
    );
  });

  initWordsList();
}

function initWordsList() {
  $(".list-group-item").on("click", function () {
    loadStoredWord($(this).data("word"));
    WordsModal.hide();
    setTimeout(() => {
      dismissSettingsPanel();
      scaleFontSize();
    }, 500);
  });
}

function loadStoredWord(word) {
  const selectedWord = wordsArchive.words.find((item) => item.word === word);

  if (selectedWord) {
    // Set text labels
    setTimeout(() => {
      WordLabel.html(selectedWord.word);
      WordInput.val(selectedWord.word);
      PronounceLabel.html(selectedWord.pronounce);
      PronounceInput.val(selectedWord.pronounce);
      WordTypeLabel.html(selectedWord.wordtype);
      WordTypeInput.val(selectedWord.wordtype);
      DescriptionLabel.html(selectedWord.description);
      DescriptionInput.val(selectedWord.description);
    }, 500);
  }
}

// For searching the words list
$("input.js-search-word").on("input", function () {
  const inputVal = $(this).val();
  const match = searchWords(inputVal);

  wordsList.html("");

  if (match.length !== 0) {
    match.forEach((word) => {
      wordsList.append(
        `<a href="#" class="list-group-item list-group-item-action" data-word="${word.word}">${word.word}</a>`,
      );
    });

    initWordsList();
  } else {
    wordsList.append(
      `<p class="text-center">${t("dictionary.archive.noResults")}</p>`,
    );
  }

  $('.js-clear-input[data-field-id="search-list"]').toggle(inputVal !== "");
});

function searchWords(query) {
  // Convert the query to lowercase for case-insensitive search
  query = query.toLowerCase();

  // Filter the words array to find matching items
  const matchingWords = wordsArchive.words.filter((word) => {
    return word.word.toLowerCase().includes(query);
  });

  return matchingWords;
}

// For getting predefined word from url var
function getWordFromQuery() {
  const regex = new RegExp("[\\?&]word=([^&#]*)");
  const results = regex.exec(window.location.search);
  wordQueryParam =
    results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  wordQueryParam =
    wordQueryParam.charAt(0).toUpperCase() + wordQueryParam.slice(1);

  if (wordQueryParam !== null && wordQueryParam !== "") {
    loadStoredWord(wordQueryParam);
    dismissSettingsPanel();
  }
}

// For hiding some unnecessary fields on staging
function toggleProductionEnv() {
  if (process.env.USE_CART === "false") {
    $(".concept-copy").hide();
  }
  if (process.env.OAK_FRAMES === "false") {
    $('[data-frame="oak"]').remove();
  }
}

// For removing default values from poster
function sanitizePosterInput(value) {
  if (value === undefined || value === null || value === "undefined") {
    return "";
  }

  value = String(value);

  var defaultValues = [
    t("dictionary.editor.defaultWord"),
    t("dictionary.editor.defaultPronunciation"),
    t("dictionary.editor.defaultType"),
    t("dictionary.editor.defaultDescription"),
    "Jouw woord",
    "[Uitspraak]",
    "Woordtype",
    "Definitie van jouw woord...",
    "Ihr Wort",
    "[Aussprache]",
    "Wortart",
    "Definition Ihres Wortes...",
  ];

  var isMatch = false;

  for (var i = 0; i < defaultValues.length; i++) {
    if (defaultValues[i] === value) {
      isMatch = true;
      break;
    }
  }

  if (isMatch) {
    return "";
  } else {
    return value;
  }
}

// For saving design to local storage
function saveDesign() {
  localStorage.setItem("posterSize", PosterSize);
  localStorage.setItem("posterFrame", PosterFrame);
  localStorage.setItem("WordLabel", WordLabel.html());
  localStorage.setItem("PronounceLabel", PronounceLabel.html());
  localStorage.setItem("WordTypeLabel", WordTypeLabel.html());
  localStorage.setItem("DescriptionLabel", DescriptionLabel.html());
  localStorage.setItem("printType", PrintType);
  localStorage.setItem("acrylBlock", AcrylBlock);
  localStorage.setItem("aluminiumColor", AluminiumColor);
}

// For getting design from local storage or parameters
function getSavedPoster() {
  // Prepare text labels
  if (BuilderName !== "PrintApp") {
    WordsModal = new bootstrap.Modal(document.getElementById("words-modal"));

    if (options.get("WordLabel") !== null) {
      var wordLabel = options.get("WordLabel");
    } else {
      var wordLabel = t("dictionary.editor.defaultWord");
    }

    if (options.get("PronounceLabel") !== null) {
      var pronounceLabel = options.get("PronounceLabel");
    } else {
      var pronounceLabel = t("dictionary.editor.defaultPronunciation");
    }

    if (options.get("WordTypeLabel") !== null) {
      var wordTypeLabel = options.get("WordTypeLabel");
    } else {
      var wordTypeLabel = t("dictionary.editor.defaultType");
    }

    if (options.get("DescriptionLabel") !== null) {
      var descriptionLabel = options.get("DescriptionLabel");
    } else {
      var descriptionLabel = t("dictionary.editor.defaultDescription");
    }
  } else {
    var wordLabel = options.get("WordLabel");
    var pronounceLabel = options.get("PronounceLabel");
    var wordTypeLabel = options.get("WordTypeLabel");
    var descriptionLabel = options.get("DescriptionLabel");
  }

  // Set text labels
  if (!wordQueryParam) {
    WordLabel.html(wordLabel);
    WordInput.val(wordLabel);
    PronounceLabel.html(pronounceLabel);
    PronounceInput.val(pronounceLabel);
    WordTypeLabel.html(wordTypeLabel);
    WordTypeInput.val(wordTypeLabel);
    DescriptionLabel.html(descriptionLabel);
    DescriptionInput.val(descriptionLabel);
  }

  if (PrintType !== "acryl" && PrintType !== "aluminium") {
    if (PosterSize === "xs") {
      PosterSize = "small";
    }
    if (PrintType === "framed-poster") {
      PrintType = "paper";
    }
  }

  if (BuilderName !== "PrintApp") {
    setStandSelection(AcrylBlock);
    setPrintStand(AcrylBlock);
  }

  PosterSizeSelect.val(PosterSize);
  setPosterSize(PosterSize);
  PrintTypeSelect.val(PrintType);
  setPrintType(PrintType);
  togglePrintTypes();
  setAluminiumColorSelection(AluminiumColor);
  activateGiftwrap();
}

// Resize canvas
$(window).resize(function () {
  resizePosterWrapper();
});

function resizePosterWrapper() {
  resizePosterPreview();
}

window.visualViewport?.addEventListener("resize", resizePosterWrapper);

// Toggle settings panels
$(".js-settings-toggle").on("click", function () {
  var target = $(this).attr("data-target");
  $(".nav-link").removeClass("active");
  $(".nav-link[data-target=" + target + "]").addClass("active");

  if (target == "text" && SettingsPanel !== "text") {
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.text").removeClass("d-none");
    SettingsPanel = "text";
  } else if (target == "size" && SettingsPanel !== "size") {
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.size").removeClass("d-none");
    SettingsPanel = "size";
  } else if (target == "shop" && SettingsPanel !== "shop") {
    setPosterSummary();
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.shop").removeClass("d-none");
    $(".nav-pills .nav-link").removeClass("active");
    $("#pills-shop-tab").addClass("active");
    SettingsPanel = "shop";
  }

  if (ShowMobileSettingPanel == false) {
    $(".side-nav").addClass("shown");
    ShowMobileSettingPanel = true;
  }
  $(".options-container").scrollTop(0);
  saveDesign();
});

$(".js-close-settings").on("click", function () {
  dismissSettingsPanel();
});

function dismissSettingsPanel() {
  $(".side-nav").removeClass("shown");
  ShowMobileSettingPanel = false;
}

function isPrintApp() {
  return $("html").hasClass("PrintApp");
}

// Prepping shopping cart
function setPosterSummary() {
  getShoppingBagSummary(PosterSize, PrintType, PosterFrame, AcrylBlock, t);
  $(".js-shipping-date").html(getShippingDate({ t, formatDate }));
  createPosterPreview();
}

function getProductVariation() {
  const variationKey =
    PrintType === "paper" ? `${PosterSize}-${PosterFrame}` : PosterSize;
  const configuredProduct = resolveCatalogProduct(
    marketContext.catalog,
    "dictionary",
    PrintType,
    variationKey,
  );
  if (configuredProduct) {
    return {
      id: configuredProduct.id,
      variation_id: configuredProduct.variationId,
    };
  }
  return { id: null, variation_id: null };
}

// Adding poster to cart
$(".js-save-poster").on("click", async function () {
  saveDesign();
  let ProductID = getProductVariation();

  $(this)
    .html(
      `${t("actions.savingDesign")} <span class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>`,
    )
    .prop("disabled", true);

  let thumbnailUrl;
  try {
    thumbnailUrl = await uploadProductScreenshot(
      PosterPreviewImage,
      BuilderName,
    );
  } catch (error) {
    console.error("Product screenshot kon niet worden opgeslagen", error);
    $(this).html(t("actions.addToCart")).prop("disabled", false);
    $(".js-notifications").append(
      `<div class="js-error alert alert-danger text-center p-2">${t("sportsmap.errors.saveFailed")}</div>`,
    );
    return;
  }

  let payload = {
    "add-builder-item-to-cart": true,
    edit_url: getBuilderUrl(marketContext, "woordenboek-poster", "/?preview"),
    thumbnail: thumbnailUrl,
    product_id: ProductID.id,
    ...(PrintType !== "tegel" && {
      variation_id: ProductID.variation_id,
    }),
    poster: {
      printType: PrintType,
      size: PosterSize,
      giftwrap: PosterGiftwrapSelect.val(),
      giftcardText: GiftCardText,
      wordLabel: sanitizePosterInput(localStorage.getItem("WordLabel")),
      pronounceLabel: sanitizePosterInput(
        localStorage.getItem("PronounceLabel"),
      ),
      wordTypeLabel: sanitizePosterInput(localStorage.getItem("WordTypeLabel")),
      descriptionLabel: sanitizePosterInput(
        localStorage.getItem("DescriptionLabel"),
      ),
      main: sanitizePosterInput(localStorage.getItem("WordLabel")),
      ...(["aluminium"].includes(PrintType) && {
        aluminiumColor: localStorage.getItem("aluminiumColor"),
      }),
      ...(["aluminium", "acryl", "tegel"].includes(PrintType) && {
        acrylBlock: localStorage.getItem("acrylBlock"),
      }),
      ...(["paper"].includes(PrintType) && {
        frame: PosterFrame,
      }),
    },
    pdf: {
      type: "woordenboek",
      print:
        PrintType === "paper" && PosterFrame !== "no-frame"
          ? "framed-poster"
          : PrintType,
    },
  };

  // console.log("Payload: ", payload);

  let action =
    process.env.USE_CART === "true" ? "add-to-cart" : "add-poster-order";
  const endpoint = apiBase + "/wp-json/wallable/v1/" + action;
  let didRetryAsForm = false;

  const runAjax = (useFormEncoding = false) => {
    return $.ajax({
      url: endpoint,
      type: "POST",
      timeout: 20000,

      ...(useFormEncoding
        ? {
            data: { payload: JSON.stringify(payload) },
          }
        : {
            contentType: "application/json",
            data: JSON.stringify(payload),
          }),

      error: (jqXHR, textStatus, errorThrown) => {
        if (!useFormEncoding && !didRetryAsForm && jqXHR?.status === 0) {
          didRetryAsForm = true;
          return runAjax(true);
        }

        console.error(jqXHR, textStatus, errorThrown);

        setTimeout(() => {
          if (!$(".js-notifications").find(".js-error").length) {
            $(".js-notifications").append(
              `<div class="js-error alert alert-danger text-center p-2">${t("errors.generic")}</div>`,
            );
          }

          debugReporter.show({
            meta: { action, didRetryAsForm },
            request: {
              url: endpoint,
              method: "POST",
              mode: useFormEncoding ? "form" : "json",
              origin: window.location.origin,
              woocommerceUrl,
              online: navigator.onLine,
              visibilityState: document.visibilityState,
            },
            response: {
              status: jqXHR?.status,
              statusText: jqXHR?.statusText || textStatus,
              thrownError: errorThrown ? String(errorThrown) : null,
              responseText: (jqXHR?.responseText || "").slice(0, 4000),
            },
          });

          $(this).html(t("actions.addToCart")).prop("disabled", false);
        }, 500);
      },

      success: () => {
        if (action === "add-to-cart") {
          $(this).html(t("actions.addToCart")).prop("disabled", false);

          window.location = woocommerceUrl + "/cart/";
        } else {
          if (!$(".js-notifications").find(".js-error").length) {
            $(".js-notifications").append(
              `<div class="js-success alert alert-success text-center p-2">&#x2713; ${t("actions.posterAdded")}</div>`,
            );
          }
          $(this).html(t("actions.addToCart")).prop("disabled", false);
        }
      },
    });
  };

  runAjax(false);
});

// Tooltips
if (!isPrintApp()) {
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]'),
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
}
